/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Question16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            d="M8 1a7 7 0 110 14A7 7 0 018 1zm0 1a6 6 0 100 12A6 6 0 008 2zm-.237 8.196a.975.975 0 01.894.572c.05.114.075.236.075.368a.926.926 0 01-.589.869.993.993 0 01-.38.072 1.01 1.01 0 01-.385-.072.913.913 0 01-.508-.498.917.917 0 01-.075-.37.933.933 0 01.583-.866.975.975 0 01.385-.075zm.254-6.297c.344 0 .655.045.932.137.277.092.512.223.707.393.194.17.343.376.448.616.104.24.157.507.157.8 0 .283-.039.525-.116.727a1.983 1.983 0 01-.294.527c-.12.15-.25.28-.39.388l-.402.306a3.164 3.164 0 00-.33.28.579.579 0 00-.173.308l-.154.77H7.236l-.122-.886-.008-.066c-.002-.022-.002-.043-.002-.066 0-.16.038-.302.115-.423.077-.121.174-.232.292-.333.117-.1.243-.198.379-.291.136-.094.262-.195.38-.303.117-.108.214-.229.291-.363a.938.938 0 00.116-.476.67.67 0 00-.218-.525c-.145-.13-.343-.195-.596-.195-.195 0-.357.02-.487.06-.13.04-.242.086-.336.135-.093.05-.175.095-.245.135a.416.416 0 01-.208.06.38.38 0 01-.353-.203l-.45-.693c.135-.114.283-.22.442-.319.16-.099.331-.186.514-.261.184-.075.38-.134.592-.176.21-.042.439-.064.685-.064z"
        />
    </AccessibleSVG>
);

export default Question16;
